import React from 'react'
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import { Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

    containerCompoenet:{ 
        position: "fixed",
        bottom: 0,
        width: "100%",
       [theme.breakpoints.up('md')]: {
         //bottom: "10vh",
         left: "30%",
         width: "40%",
       },
       //backgroundColor:"blue",
     },

    contentPaper:{  
        width: "100%",
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        alignItems:'flex-start',
        height: 'auto',
        padding: theme.spacing(1),
    }, 

   buttons: {
    display: 'flex',
    flexDirection:'row',
    justifyContent: 'center',
    width: "100%",
    padding: theme.spacing(1,1,1,1),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3,3,3,3),
    }
   
   },

   contentNext: {
    display: 'flex',
    flexDirection:'row',
    justifyContent: 'center',
    minWidth: "60%",
    marginLeft:"10%",
    //backgroundColor:"blue"
   },

   buttonNext: {
    width: "100%",
   },

   buttonBack: {
    minWidth: "40%"
   },

}));


export default function PanelButtons(props) {
    const classes = useStyles();
    const {
        labelNext,
        labelCancel,
        onClickCancel,
        onClickNext,
        nextDisabled,
        nextColor,
        } = props; 
    

    return (
        <Paper className={classes.containerCompoenet} square elevation={4}>
            
            <div className={classes.buttons}>
                {labelCancel && 
                    <Button
                    variant="primary"
                    size='large' 
                    color='text'
                    onClick={onClickCancel}
                    >
                    {labelCancel} 
                    </Button>
                }
                {labelNext && 
                <div  className={classes.contentNext } >
                <Button
                 variant="contained" 
                 color={nextColor? nextColor: "accent"}
                 size='large' 
                 onClick = {onClickNext}   
                 disabled={nextDisabled} 
                 className={classes.buttonNext }           
                 >
                    {labelNext}
                 </Button>
                 </div>
                }

            </div>
      </Paper>
    )
}
